export default [

     {
          path: '/general-relation',
          name: 'GeneralRelation',
          component: () => import("@/views/Page/GeneralRelation/GeneralRelation.vue"),
           meta: {
               title: 'EGRC | GeneralRelation',
          },
     }
];